import React from "react";
import { cn } from "@/lib/utils";

/**
 * "Move to…" on a board card: the way to move a card on a touch screen (where dragging doesn't work), and for the keyboard.
 * Shown on hover with a mouse, always on touch screens.
 */
export function MoveSelect({ label, options, onPick, className }: { label: string; options: { value: string; label: string }[]; onPick: (value: string) => void; className?: string }) {
  if (!options.length) return null;
  return (
    <select
      aria-label={label}
      value=""
      draggable={false}
      onClick={(e) => e.stopPropagation()}
      onChange={(e) => e.target.value && onPick(e.target.value)}
      className={cn("h-6 max-w-full rounded border border-border bg-background px-1 text-[11px] text-muted-foreground opacity-0 transition-opacity focus:opacity-100 group-hover/card:opacity-100 [@media(hover:none)]:opacity-100", className)}
    >
      <option value="">Move to…</option>
      {options.map((o) => (
        <option key={o.value} value={o.value}>
          {o.label}
        </option>
      ))}
    </select>
  );
}
